"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _modelUtil = _interopRequireDefault(require("@leverege/model-util"));

var _HoursModel = _interopRequireDefault(require("./HoursModel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TYPE = 'recovr.locationHours';

function getName() {
  return 'Location Hours';
}

function create() {
  return {
    type: TYPE,
    timeZone: 'America/New_York',
    exceptions: [],
    days: {}
  };
}

var _default = {
  create,
  TYPE,
  getName,
  ..._modelUtil.default.createAllValue('timeZone'),
  ..._modelUtil.default.createAllArray('exceptions'),
  ..._modelUtil.default.createAllValue('days/mon', 'mondayHours', {
    validate: _HoursModel.default.validate
  }, {
    defaultValue: _HoursModel.default.create()
  }),
  ..._modelUtil.default.createAllValue('days/tue', 'tuesdayHours', {
    validate: _HoursModel.default.validate
  }, {
    defaultValue: _HoursModel.default.create()
  }),
  ..._modelUtil.default.createAllValue('days/wed', 'wednesdayHours', {
    validate: _HoursModel.default.validate
  }, {
    defaultValue: _HoursModel.default.create()
  }),
  ..._modelUtil.default.createAllValue('days/thu', 'thursdayHours', {
    validate: _HoursModel.default.validate
  }, {
    defaultValue: _HoursModel.default.create()
  }),
  ..._modelUtil.default.createAllValue('days/fri', 'fridayHours', {
    validate: _HoursModel.default.validate
  }, {
    defaultValue: _HoursModel.default.create()
  }),
  ..._modelUtil.default.createAllValue('days/sat', 'saturdayHours', {
    validate: _HoursModel.default.validate
  }, {
    defaultValue: _HoursModel.default.create()
  }),
  ..._modelUtil.default.createAllValue('days/sun', 'sundayHours', {
    validate: _HoursModel.default.validate
  }, {
    defaultValue: _HoursModel.default.create()
  })
};
exports.default = _default;